import React from 'react';
import styles from './ConfidenceBadge.module.css';

interface ConfidenceBadgeProps {
  confidence: number;
}

function getLevel(confidence: number): 'green' | 'yellow' | 'red' {
  if (confidence >= 85) return 'green';
  if (confidence >= 70) return 'yellow';
  return 'red';
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ confidence }) => {
  const level = getLevel(confidence);

  return (
    <span className={`${styles.badge} ${styles[level]}`}>
      <span className={styles.dot} />
      {confidence}%
    </span>
  );
};

export default ConfidenceBadge;
